import React from "react";
import { HTTPMethod } from "../../models/Entities";
import { snakeCaseToTitleCase } from "../../services";
import HttpStatusCode from "./utils/HttpStatusCode";
import { Badge } from "@merge-api/merge-javascript-shared";
import { BaseColor } from "@merge-api/merge-javascript-shared/dist/designSystem/types";

type ResponseCodeBadgeProps = {
  responseCode: number;
  size?: "sm" | "md" | "lg" | undefined;
};

const EM_DASH = <span className="text-gray-40">&mdash;</span>;

export const ResponseCodeBadge = ({ responseCode, size = "md" }: ResponseCodeBadgeProps) => {
  if (responseCode === undefined || responseCode === null) {
    return EM_DASH;
  }
  const isOKResponse = responseCode >= 200 && responseCode <= 299;
  const text =
    responseCode === 200
      ? "200 OK"
      : String(responseCode) + " " + snakeCaseToTitleCase(HttpStatusCode[responseCode]);

  return (
    <Badge color={isOKResponse ? "green" : "red"} size={size}>
      {text}
    </Badge>
  );
};

type HTTPMethodBadgeProps = {
  method: HTTPMethod | string;
  size?: "sm" | "md" | "lg" | undefined;
};

export const HTTPMethodBadge = ({ method, size = "md" }: HTTPMethodBadgeProps) => {
  let color;

  switch (method) {
    case HTTPMethod.GET:
      color = "blue";
      break;
    case HTTPMethod.POST:
      color = "green";
      break;
    case HTTPMethod.PUT:
      color = "green";
      break;
    case HTTPMethod.DELETE:
      color = "red";
      break;
    case HTTPMethod.PATCH:
      color = "gray";
      break;
    case HTTPMethod.OPTIONS:
      color = "purple";
      break;
    case HTTPMethod.HEAD:
      color = "yellow";
      break;
    case "FETCH":
      color = "blue";
      break;
    default:
      color = "blue";
      break;
  }

  return (
    <Badge color={color as BaseColor} size={size}>
      {method}
    </Badge>
  );
};
